export function rgbToHsv(rgb: { r: number; g: number; b: number } | null): {
  h: number;
  s: number;
  v: number;
} {
  if (rgb == null) return { h: 0, s: 0, v: 0 };
  const r = rgb.r / 255;
  const g = rgb.g / 255;
  const b = rgb.b / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;

  let h = 0;
  let s = 0;
  const v = max;

  if (delta !== 0) {
    s = delta / max;
    if (max === r) {
      h = (60 * ((g - b) / delta) + 360) % 360;
    } else if (max === g) {
      h = (60 * ((b - r) / delta) + 120) % 360;
    } else {
      h = (60 * ((r - g) / delta) + 240) % 360;
    }
  }

  return { h, s, v };
}
